import { useAnalytics } from 'app/context/Analytics';
import { PosthogEventName } from 'app/copied/constants/PosthogEventName';
import { useCallback } from 'react';

export default function useContactFormTracking() {
  const { captureEventWithActiveScreen } = useAnalytics();

  const captureContactFormOpened = useCallback(() => {
    captureEventWithActiveScreen(PosthogEventName.ContactFormOpened);
  }, [captureEventWithActiveScreen]);

  const captureContactFormView = useCallback(
    (pageNumber: number) => {
      captureEventWithActiveScreen(PosthogEventName.ContactFormView, {
        pageNumber,
      });
    },
    [captureEventWithActiveScreen]
  );

  const captureContactFormContinue = useCallback(
    (pageNumber: number) => {
      captureEventWithActiveScreen(PosthogEventName.ContactFormContinue, {
        pageNumber,
      });
    },
    [captureEventWithActiveScreen]
  );

  const captureContactFormClosed = useCallback(
    (pageNumber: number) => {
      captureEventWithActiveScreen(PosthogEventName.ContactFormClosed, {
        pageNumber,
      });
    },
    [captureEventWithActiveScreen]
  );

  const captureContactFormComplete = useCallback(
    (pageNumber: number) => {
      captureEventWithActiveScreen(PosthogEventName.ContactFormComplete, {
        pageNumber,
      });
    },
    [captureEventWithActiveScreen]
  );

  const captureContactFormError = useCallback(
    (fieldName: string, message: string) => {
      captureEventWithActiveScreen(PosthogEventName.ContactFormError, { fieldName, message });
    },
    [captureEventWithActiveScreen]
  );

  const captureContactFormCheckbox = useCallback(
    ({
      fieldName,
      checked,
      required,
      text,
    }: {
      fieldName: string;
      checked: boolean;
      required: boolean;
      text: string;
    }) => {
      captureEventWithActiveScreen(PosthogEventName.ContactFormCheckbox, { fieldName, checked, required, text });
    },
    [captureEventWithActiveScreen]
  );

  return {
    captureContactFormOpened,
    captureContactFormView,
    captureContactFormContinue,
    captureContactFormClosed,
    captureContactFormComplete,
    captureContactFormError,
    captureContactFormCheckbox,
  };
}
